<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Add New Tag</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">

          <b-col sm="12">
            <base-input label="Tag Name"
                        name="name"
                        type="textarea"
                        rules="required"
                        placeholder="Tag Name"
                        v-model="model.name">
            </base-input>
          </b-col>
        </div>
        <div class="form-row">
          <b-col sm="12" md="6">
            <base-input label="Tag Group">
              <el-select
                  v-model="model.tagGroupId" 
                  filterable
                  placeholder="Select Tag Group"
                  rules="required"
                  single
                  value-key="id"
              >
                <el-option v-for="option in tagCategories"
                              :key="option.id"
                              :label="option.name"
                              :value="option.id">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </div>
        <div class="form-row">
          <b-col sm="3">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
        </div>
        <div class="form-row">

          <b-col sm="12">
            <label class="form-control-label">
              Tag Icon
            </label>
            <div class="dropzone-icon">
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  id="logoDropzone"
                  :options="dropzoneOptions"
                  ref="logo"
                />
             </div>
          </b-col>
        </div>
        <base-button type="primary" @click="addTagSubmit('/tags')">Save and Close</base-button>
        <base-button type="primary" @click="addTagSubmit('/tag/add-tag')">Save and Add Another</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  //import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import uuid from 'uuid';
  import vue2Dropzone from 'vue2-dropzone'

  export default {
    name: "AddTag",
    components: {
        HtmlEditor,
        vue2Dropzone,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions
    },
    data() {
      return {
        validated: false,
        model: {
          clientId: '',
          name: '',
          icon: '',
          dropzone: [],
          isDietary: false,
          isActive: true,
          isDeleted: false,
          isVisible: true
        },
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          uploadMultiple: false,
          maxFiles: 1,
          maxFilesize: 256,
          maxThumbnailFilesize: 256,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    methods: {
      addTagSubmit(goTo) {
        let user = this.$store.state.authentication.user.user;
        const { dispatch } = this.$store;
        this.model.recipeId = uuid();
        this.model.clientId =  user.clientId;
        this.model.iconUpload = this.$refs.logo.dropzone.files[0];

        if (this.model.name) {
          try {
              this.$delete(this.model, 'id')
              dispatch("tags/addTag", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Tag Added'});
                  const { dispatch } = this.$store;
                  dispatch("tags/getAllTags");
                  
                  
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: tag add", error);
          } finally {
            this.$router.push({path: goTo});
            this.resetForm();
          }
        }
      },
      addCollectionRow() {
        this.model.collections.push({ id: '' })
      },
      resetForm() {
        this.model.id = '';
        this.model.name = '';
        this.model.description = '';
        this.$refs.logo.removeAllFiles()
      },
      maxFilesExceeded(file) {
        this.$refs.logo.removeAllFiles()
        this.$refs.logo.addFile(file)
      },
      fileAdded(file) {
        this.model.dropzone = []
        this.model.dropzone.push(file)
      }
    },
    computed: {
      tagCategories() {
        return this.$store.state.taggroups.selectList
      }
    },
    created() {
      const { dispatch } = this.$store;
      dispatch('taggroups/getSelectList');
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
